import { implementSetAllNavTabDetailsMutation } from "../../../../dt-plugins/sidewindow/nav-tab";
import * as types from "./types";

// Mutations Object for Shop_groupsDistribution. Use it by importing shop_groups/types.js and calling commit() from  shop_groups/actions.js Action File.
export const shop_groupsDistributionMutations = {
  [types.Shop_groupsData.SET.ALL](state, payload) {
    state.shop_groupsData = payload;
  },
  [types.Shop_groupList.SET.ALL](state, payload) {
    // console.log("selected SG MUT ", state, "payload mut... ", payload);
    state.shop_groupList = payload;
  },
  ...implementSetAllNavTabDetailsMutation(
    types.Shop_groupDetails,
    "shop_groupDetails"
  )
};
